import { render, staticRenderFns } from "./ReActivateResponsibility.vue?vue&type=template&id=f7e62d8e"
import script from "./ReActivateResponsibility.vue?vue&type=script&lang=js"
export * from "./ReActivateResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports